import { useContext, useEffect, useRef, useState } from 'react';
import { SingleDatePicker } from 'react-dates';
import moment from 'moment';
import 'react-dates/lib/css/_datepicker.css';
import handleChange from '../../utils/handleChange';
import './orgTripDateTab.css';
import { OrgDatesContext } from '../../context/OrgDatesContest';
import { orgActiveTripEdit, tripDateCreateFun, unavailableDateFun } from '../../api/orgTripAPI';
import errorHandle from '../../utils/errorHandle';
import { toast } from 'react-toastify';
import { ReactComponent as Chevron } from '../../assets/icons/trvto_downArrow.svg';
import ReactLoading from 'react-loading';
import Tooltip from '../tooltip/Tooltip';
import { ReactComponent as InfoI } from '../../assets/icons/trvto_info.svg';

export default function OrgTripDateTab({ price, packData, refresh, isExpanded, setIsExpanded }) {
    const bookingTabRef = useRef(null);
    const bookingEnd = '11:58 PM';
    const [dateDetails, setDateDetails] = useState({
        startDate: '',
        totalSlots: '',
        totalRooms: '',
        price: {
            actual: '',
            tax: '',
            total: '',
            reserve: ''
        }
    });
    const [isChecked, setIsChecked] = useState(false);
    const [loading, setLoading] = useState(false);
    const [bookingEndFocused, setBookingEndFocused] = useState(null);
    const [startFocused, setStartFocused] = useState(null);
    const [endFocused, setEndFocused] = useState(null);
    const [bookingEndDate, setBookingEndDate] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [unAvailableDate, setUnAvailableDate] = useState(null);
    const [unavailableFocused, setUnavailableFocused] = useState(null);
    const notAllowedDates = useRef([]);
    const notAllowedDatescustom = useRef([]);
    const isMobile = window.innerWidth < 768;
    const { dates, upComing, setUpComing } = useContext(OrgDatesContext);

    useEffect(() => {
        const actual = Number(dateDetails.price.actual);
        if (!isNaN(actual) && actual > 0) {
            const tax = Math.round(actual * 0.05);
            const total = Math.round(actual + tax);
            setDateDetails((prev) => ({
                ...prev,
                price: {
                    ...prev.price,
                    tax,
                    total
                }
            }));
        } else {
            setDateDetails((prev) => ({
                ...prev,
                price: {
                    ...prev.price,
                    tax: '',
                    total: ''
                }
            }));
        }
    }, [dateDetails.price.actual]);

    async function addDate() {
        if (!bookingEndDate) {
            toast.error('Please select booking end date');
            return;
        } else if (!selectedDate) {
            toast.error('Please select start date');
            return;
        } else if (!endDate) {
            toast.error('Please select end date');
            return;
        } else if (!dateDetails.totalSlots) {
            toast.error('Please enter total slots');
            return;
        } else if (!dateDetails.totalRooms) {
            toast.error('Please enter total rooms');
            return;
        }
        setLoading(true);

        const packId = window.location.pathname.split('/')[4];
        const bookingEndTime = moment(bookingEnd, 'h:mm A');
        const startTime = moment(packData.quickView?.startTime, 'h:mm A').format('HH:mm');
        const endTime = moment(packData.quickView?.endTime, 'h:mm A').format('HH:mm');

        const bookingEndDateTime = bookingEndDate.clone().set({
            hour: bookingEndTime.hour(),
            minute: bookingEndTime.minute(),
            second: 0,
            millisecond: 0
        });

        const startDateTime = selectedDate.set({
            hour: startTime.split(':')[0],
            minute: 0,
            second: 0,
            millisecond: 0
        });
        const endDateTime = endDate.set({
            hour: endTime.split(':')[0],
            minute: 0,
            second: 0,
            millisecond: 0
        });
        try {
            let priceData = {};
            if (
                dateDetails.price?.actual ||
                dateDetails.price?.tax ||
                dateDetails.price?.total ||
                dateDetails.price?.reserve
            ) {
                priceData = {
                    price: {
                        actual: dateDetails.price.actual,
                        tax: dateDetails.price.tax,
                        total: dateDetails.price.total,
                        reserve: dateDetails.price.reserve
                    }
                };
            }
            const newDate = await tripDateCreateFun(packId, {
                bookingEnd: bookingEndDateTime.utc(),
                startDate: startDateTime.utc(),
                endDate: endDateTime.utc(),
                totalSlots: dateDetails.totalSlots,
                totalRooms: dateDetails.totalRooms,
                ...priceData
            });
            //clear the old date and slot values
            if (newDate.status === 200) {
                toast.success('Successfully added new date');
                setSelectedDate(null);
                setBookingEndDate(null);
                setEndDate(null);
                setDateDetails({
                    startDate: '',
                    totalSlots: '',
                    totalRooms: '',
                    price: { actual: '', tax: '', total: '', reserve: '' }
                });
                refresh();
                setUpComing(true);
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            errorHandle(error);
        }
    }

    async function addUnavailableDate() {
        if (!unAvailableDate) {
            toast.error('Please select unavailable date');
            return;
        }
        setLoading(true);

        const packId = window.location.pathname.split('/')[4];
        const unavailableDate = unAvailableDate.toISOString();
        try {
            const newDate = await unavailableDateFun(
                {
                    packId,
                    date: unavailableDate
                },
                'add'
            );

            //clear the old date and slot values
            if (newDate.status === 200) {
                toast.success('Successfully added new date');
                setUnAvailableDate(null);
                refresh();
                setUpComing(true);
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            errorHandle(error);
        }
    }
    useEffect(() => {
        if (isExpanded && bookingTabRef.current) {
            window.scrollTo({
                top: bookingTabRef.current.offsetTop - 160,
                behavior: 'smooth'
            });
        }
    }, [isExpanded]);

    useEffect(() => {
        // The notAllowedDates should be updated only when dates are of upcoming data
        if (upComing) {
            notAllowedDates.current = dates.map((da) => {
                return moment(da.startDate);
            });
            //Dont allow coming next two days to add trip
            // const today = new Date();
            // const twoDates = [
            //     moment(today),
            //     moment(new Date().setDate(today.getDate() + 1)),
            //     moment(new Date().setDate(today.getDate() + 2))
            // ];
            const fixedBlockDate = dates?.map((dateItem) => moment(dateItem?.startDate));
            notAllowedDates.current = [...notAllowedDates.current, ...fixedBlockDate];
        }
        //eslint-disable-next-line
    }, [dates]);

    useEffect(() => {
        // The notAllowedDates should be updated only when dates are of upcoming data
        if (upComing) {
            notAllowedDates.current = packData.unavailableDates.map((da) => {
                return moment(da);
            });
            //Dont allow coming next two days to add trip
            // const today = new Date();
            // const twoDates = [
            //     moment(today),
            //     moment(new Date().setDate(today.getDate() + 1)),
            //     moment(new Date().setDate(today.getDate() + 2))
            // ];
            const fixedBlockDate = dates?.map((dateItem) => moment(dateItem?.startDate));
            notAllowedDates.current = [...notAllowedDates.current, ...fixedBlockDate];
        }
        //eslint-disable-next-line
    }, [packData.unavailableDates]);

    const isDayBlocked = (day) => {
        return notAllowedDates.current.some((notAllowedDate) => notAllowedDate.isSame(day, 'day'));
    };

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    const handleCheckBoxChnage = (event) => {
        setIsChecked(event.target.checked);
    };

    return (
        <div ref={bookingTabRef} className={`tripBookingTab ${isExpanded ? 'expanded' : 'collapsed'}`}>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            {packData.datesType === 'custom' ? (
                <>
                    <div className='orgTrDaTabPriceDiv'>
                        <div className='flexColumn'>
                            <span className='orgTrDaTabPrice'>Rs. {price.customPrice.perPerson}/person</span>
                            <span className='orgTrDaTabIncu'>Excluding all taxes</span>
                        </div>
                        <div className='tripBookingChevronWrapper'>
                            <button onClick={toggleExpand} className='collapseArrow'>
                                <Chevron width={24} height={24} />
                            </button>
                            {!isExpanded && window.innerWidth < 768 && (
                                <button type='button' className='dateAddBtn blueBtn' onClick={toggleExpand}>
                                    Add Unavailable Date
                                </button>
                            )}
                        </div>
                    </div>
                    <div className='tripBookingSubTab'>
                        <label className='tripBookDatalabel2'>Select unavailable Date</label>
                        <SingleDatePicker
                            withPortal={isMobile}
                            date={unAvailableDate}
                            onDateChange={(date) => {
                                setUnAvailableDate(date);
                            }}
                            displayFormat='DD-MM-YYYY'
                            focused={unavailableFocused}
                            onFocusChange={({ focused }) => setUnavailableFocused(focused)}
                            numberOfMonths={1}
                            isDayBlocked={isDayBlocked}
                            isOutsideRange={(day) => day.isBefore(moment(), 'day')} // Disable past dates
                            showDefaultInputIcon={true} // shows calendar icon
                            readOnly={true}
                        />
                        {/*  <label className='tripBookDatalabel2'>Start Date</label>
                       <SingleDatePicker
                            withPortal={isMobile}
                            date={selectedDate}
                            onDateChange={(date) => {
                                setSelectedDate(date);
                            }}
                            displayFormat='DD-MM-YYYY'
                            focused={startFocused}
                            onFocusChange={({ focused }) => setStartFocused(focused)}
                            numberOfMonths={1}
                            isDayBlocked={isDayBlocked}
                            isOutsideRange={(day) => day.isBefore(moment(), 'day')} // Disable past dates
                            showDefaultInputIcon={true} // shows calendar icon
                            readOnly={true}
                        />
                        <label className='tripBookDatalabel2'>End Date</label>
                        <SingleDatePicker
                            withPortal={isMobile}
                            date={endDate}
                            onDateChange={(date) => {
                                setEndDate(date);
                            }}
                            displayFormat='DD-MM-YYYY'
                            focused={endFocused}
                            onFocusChange={({ focused }) => setEndFocused(focused)}
                            numberOfMonths={1}
                            isOutsideRange={(day) => day.isBefore(moment(), 'day')} // Disable past dates
                            showDefaultInputIcon={true} // shows calendar icon
                            readOnly={true}
                        />
                        <label className='tripBookDatalabel2'>Slots</label>
                        <input
                            placeholder='Slots'
                            type='number'
                            value={dateDetails.totalSlots}
                            name='totalSlots'
                            className='orgTrDaTabSlotIn'
                            onChange={(e) => handleChange(e, setDateDetails)}
                        />
                        <label className='tripBookDatalabel2 roomsInputLable'>Rooms</label>
                        <input
                            placeholder='Rooms'
                            type='number'
                            value={dateDetails.totalRooms}
                            name='totalRooms'
                            className='orgTrDaTabSlotIn'
                            onChange={(e) => handleChange(e, setDateDetails)}
                        /> */}
                        <button type='button' className='dateAddBtn blueBtn' onClick={addUnavailableDate}>
                            Add Unavailable Date
                        </button>
                    </div>
                </>
            ) : (
                <>
                    <div className='orgTrDaTabPriceDiv'>
                        <div className='flexColumn'>
                            <span className='orgTrDaTabPrice'>Rs. {price.price.total}/person</span>
                            <span className='orgTrDaTabIncu'>Including all taxes</span>
                        </div>
                        <div className='tripBookingChevronWrapper'>
                            <button onClick={toggleExpand} className='collapseArrow'>
                                <Chevron width={24} height={24} />
                            </button>
                            {!isExpanded && window.innerWidth < 768 && (
                                <button type='button' className='dateAddBtn blueBtn' onClick={toggleExpand}>
                                    Add New Date
                                </button>
                            )}
                        </div>
                    </div>
                    <div className='tripBookingSubTab'>
                        <label className='tripBookDatalabel2'>Start Date</label>
                        <SingleDatePicker
                            withPortal={isMobile}
                            date={selectedDate}
                            onDateChange={(date) => {
                                setSelectedDate(date);
                            }}
                            displayFormat='DD-MM-YYYY'
                            focused={startFocused}
                            onFocusChange={({ focused }) => setStartFocused(focused)}
                            numberOfMonths={1}
                            isDayBlocked={isDayBlocked}
                            isOutsideRange={(day) => day.isBefore(moment(), 'day')} // Disable past dates
                            showDefaultInputIcon={true} // shows calendar icon
                            readOnly={true}
                        />
                        <label className='tripBookDatalabel2'>End Date</label>
                        <SingleDatePicker
                            withPortal={isMobile}
                            date={endDate}
                            onDateChange={(date) => {
                                setEndDate(date);
                            }}
                            displayFormat='DD-MM-YYYY'
                            focused={endFocused}
                            onFocusChange={({ focused }) => setEndFocused(focused)}
                            numberOfMonths={1}
                            isOutsideRange={
                                (day) =>
                                    day.isBefore(moment(), 'day') || // block past
                                    (selectedDate && day.isBefore(selectedDate, 'day')) // block before selected start date
                            }
                            showDefaultInputIcon={true} // shows calendar icon
                            readOnly={true}
                        />
                        <label className='tripBookDatalabel2'>Booking End Date</label>
                        <SingleDatePicker
                            withPortal={isMobile}
                            date={bookingEndDate}
                            onDateChange={(date) => {
                                setBookingEndDate(date);
                            }}
                            displayFormat='DD-MM-YYYY'
                            focused={bookingEndFocused}
                            onFocusChange={({ focused }) => setBookingEndFocused(focused)}
                            numberOfMonths={1}
                            isOutsideRange={
                                (day) =>
                                    day.isBefore(moment(), 'day') || // Disable past dates
                                    (selectedDate && day.isAfter(selectedDate, 'day')) // Disable after booking start date
                            }
                            showDefaultInputIcon={true}
                            readOnly={true}
                        />

                        <label className='tripBookDatalabel2'>Slots</label>
                        <input
                            placeholder='Slots'
                            type='number'
                            value={dateDetails.totalSlots}
                            name='totalSlots'
                            className='orgTrDaTabSlotIn'
                            onChange={(e) => handleChange(e, setDateDetails)}
                        />
                        <div style={{ marginTop: -20 }}>
                            <label className='tripBookDatalabel2 roomsInputLable'>Rooms</label>
                            <Tooltip
                                content='Enter the number of available rooms. If there is no rooms then enter 0.'
                                position='top'
                            >
                                <span className='eyeIcon' style={{ marginLeft: 5 }}>
                                    <InfoI color='blue' width={15} height={15} />
                                </span>
                            </Tooltip>
                        </div>
                        <input
                            placeholder='Rooms'
                            type='number'
                            value={dateDetails.totalRooms}
                            name='totalRooms'
                            className='orgTrDaTabSlotIn'
                            onChange={(e) => handleChange(e, setDateDetails)}
                        />
                        <div id='org-checkbox-div' style={{ marginTop: '-10px', marginBottom: '30px' }}>
                            <input
                                type='checkbox'
                                id='customCheck'
                                checked={isChecked}
                                onChange={handleCheckBoxChnage}
                            />
                            <label htmlFor='customCheck' id='tripReserveLabel'>
                                If you want to add special price for this date
                            </label>
                        </div>
                        {isChecked && (
                            <>
                                <label className='tripBookDatalabel2 roomsInputLable'>Actual</label>
                                <input
                                    placeholder='Actual price'
                                    type='number'
                                    value={dateDetails.price.actual}
                                    name='actual'
                                    className='orgTrDaTabSlotIn'
                                    onChange={(e) => handleChange(e, setDateDetails, 'price')}
                                    onWheel={(e) => e.target.blur()}
                                />
                                <label className='tripBookDatalabel2 roomsInputLable'>Tax</label>
                                <input
                                    placeholder='Tax'
                                    type='number'
                                    value={dateDetails.price.tax}
                                    name='tax'
                                    className='orgTrDaTabSlotIn'
                                    onChange={(e) => handleChange(e, setDateDetails, 'price')}
                                />
                                <label className='tripBookDatalabel2 roomsInputLable'>Total</label>
                                <input
                                    placeholder='Total Price'
                                    type='number'
                                    value={dateDetails.price.total}
                                    name='total'
                                    className='orgTrDaTabSlotIn'
                                    onChange={(e) => handleChange(e, setDateDetails, 'price')}
                                />
                                <label className='tripBookDatalabel2 roomsInputLable'>Reserve</label>
                                <input
                                    placeholder='Reserve Price'
                                    type='number'
                                    value={dateDetails.price.reserve}
                                    name='reserve'
                                    className='orgTrDaTabSlotIn'
                                    onChange={(e) => handleChange(e, setDateDetails, 'price')}
                                />
                            </>
                        )}
                        <button type='button' className='dateAddBtn blueBtn' onClick={addDate}>
                            Add New Date
                        </button>
                    </div>
                </>
            )}
        </div>
    );
}
